"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceStoreAuthLevel = exports.PreferenceTopicType = exports.PreferenceUpdateItem = exports.PreferenceStorePurposeUpdate = exports.PreferenceStoreWorkflowSettings = exports.CustomFieldApiInput = exports.PreferenceQueryResponseItem = exports.PreferenceStorePurposeResponse = exports.Preference = exports.PreferenceStoreKeyConditionals = exports.PreferenceStoreConsentFields = exports.PreferenceStoreSystemAttributes = exports.PreferenceStoreIdentifier = exports.DecryptionStatus = void 0;
const t = __importStar(require("io-ts"));
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * Types of decryption status
 */
exports.DecryptionStatus = (0, type_utils_1.makeEnum)({
    DECRYPTED: 'DECRYPTED',
    ERROR: 'ERROR',
});
/**
 * Preference store identifier
 */
exports.PreferenceStoreIdentifier = t.type({
    /** The identifier name (email, phone etc) */
    name: t.string,
    /** The identifier value */
    value: t.string,
});
/**
 * Preference store system attributes which are not user editable
 */
exports.PreferenceStoreSystemAttributes = t.intersection([
    t.type({
        /** The decrypted status of the record */
        decryptionStatus: (0, type_utils_1.valuesOf)(exports.DecryptionStatus),
    }),
    t.partial({
        /** updated timestamp on the db record */
        updatedAt: t.string,
    }),
]);
/**
 *  Contains all the Consent management related fields
 *  that are stored in the preference store.
 */
exports.PreferenceStoreConsentFields = t.type({
    /** US IAB Privacy String */
    usp: t.union([t.string, t.null]),
    /** IAB GPP String */
    gpp: t.union([t.string, t.null]),
    /** IAB TCF String */
    tcf: t.union([t.string, t.null]),
    /** Airgap Version */
    airgapVersion: t.union([t.string, t.null]),
});
/**
 * The format key required fields of the preference store record
 */
exports.PreferenceStoreKeyConditionals = t.type({
    /** The partition key */
    partition: t.string,
    /** last consent event timestamp (ISO 8601) */
    timestamp: t.string,
});
/** The format for a preference which include topic and user choice */
exports.Preference = t.type({
    /** The preference topic */
    topic: t.string,
    /** The preference choice made by the user */
    choice: t.partial({
        /** The boolean value of the preference */
        booleanValue: t.union([t.boolean, t.null]),
        /** The select value of the preference */
        selectValue: t.union([t.string, t.null]),
        /** The select values of the preference */
        selectValues: t.union([t.array(t.string), t.null]),
    }),
});
/**
 * The format for a preference store purpose
 */
exports.PreferenceStorePurposeResponse = t.intersection([
    t.type({
        /** tracking purpose */
        purpose: t.string,
        /** Whether the purpose is enabled */
        enabled: t.boolean,
    }),
    t.partial({
        /** additional preference associated with this purpose */
        preferences: t.array(exports.Preference),
    }),
]);
exports.PreferenceQueryResponseItem = t.intersection([
    exports.PreferenceStoreKeyConditionals,
    t.type({
        /** The system attributes of the record */
        system: exports.PreferenceStoreSystemAttributes,
        /** Consent management related fields */
        consentManagement: t.partial(exports.PreferenceStoreConsentFields.props),
        /** Preference store purposes */
        purposes: t.array(exports.PreferenceStorePurposeResponse),
    }),
    t.partial({
        /** Primary identifier of the user. */
        userId: t.string,
        /** Identifiers associated to the user */
        identifiers: t.array(exports.PreferenceStoreIdentifier),
        /** metadata */
        metadata: t.array(t.type({
            key: t.string,
            value: t.string,
        })),
        /** last updated for metadata */
        metadataTimestamp: t.string,
    }),
]);
exports.CustomFieldApiInput = t.type({
    /** The attribute key that houses the attribute values */
    key: t.string,
    /** The attribute values used to label resources */
    values: t.array(t.string),
});
/** The format of the preference store workflow settings */
exports.PreferenceStoreWorkflowSettings = t.partial({
    /** Additional tags to forward to the DSR event */
    attributes: t.array(exports.CustomFieldApiInput),
    /** Data silo IDs to run the workflow on */
    dataSiloIds: t.array(t.string),
    /** The email template ID to use for the receipt */
    emailReceiptTemplateId: t.string,
    /** Data silo IDs to ignore when running the workflow */
    ignoreDataSiloIds: t.array(t.string),
    /** If the workflow is silent */
    isSilent: t.boolean,
    /** if the workflow is a test run */
    isTest: t.boolean,
    /** if the workflow should skip sending the receipt */
    skipSendingReceipt: t.boolean,
    /** if the workflow should skip the waiting period */
    skipWaitingPeriod: t.boolean,
    /** if the workflow should be skipped */
    skipWorkflowTrigger: t.boolean,
});
/**
 * The format for a preference store purpose
 */
exports.PreferenceStorePurposeUpdate = t.intersection([
    exports.PreferenceStorePurposeResponse,
    t.partial({
        /** Timestamp of when the purpose was last updated (ISO 8601) */
        timestamp: t.string,
        /** Additional tags to forward to the DSR event */
        attributes: t.array(exports.CustomFieldApiInput),
        /** Consent workflow settings */
        workflowSettings: exports.PreferenceStoreWorkflowSettings,
        /** Language to translate request to */
        locale: t.string, // Should be LanguageKey but omitting to allow for sombra to update independently
    }),
]);
exports.PreferenceUpdateItem = t.intersection([
    exports.PreferenceStoreKeyConditionals,
    t.partial({
        /** Primary identifier of the user. */
        userId: t.string,
        /** Identifiers associated to the user */
        identifiers: t.array(exports.PreferenceStoreIdentifier),
        /** Preference store purposes */
        purposes: t.array(exports.PreferenceStorePurposeUpdate),
        /** Consent management related fields */
        consentManagement: t.partial(exports.PreferenceStoreConsentFields.props),
        /**
         * Language to translate DSR processing
         * TODO: https://transcend.height.app/T-40208 - move this to `PreferenceStoreKeyConditionals` when stored on record
         */
        locale: t.string, // Should be LanguageKey but omitting to allow for sombra to update independently
        /** The metadata associated with the record */
        metadata: t.array(t.type({
            /** metadata key */
            key: t.string,
            /**
             * metadata value
             *
             * - **null**: to remove the metadata key
             * - **string**: to set the metadata key
             */
            value: t.union([t.string, t.null]),
        })),
    }),
]);
/**
 * The supported preference topic types
 */
exports.PreferenceTopicType = (0, type_utils_1.makeEnum)({
    Select: 'SELECT',
    MultiSelect: 'MULTI_SELECT',
    Boolean: 'BOOLEAN',
});
/**
 * The authentication level required for updating a purpose on preference store
 */
exports.PreferenceStoreAuthLevel = (0, type_utils_1.makeEnum)({
    Required: 'REQUIRED',
    Optional: 'OPTIONAL',
    AllowOptOut: 'ALLOW_OPT_OUT',
});
//# sourceMappingURL=preferences.js.map